import type { HTMLAttributes } from 'react'
import { cn } from '@/shared/lib/cn'
import s from './Kbd.module.css'

type KbdProps = HTMLAttributes<HTMLElement>

export function Kbd({ className, ...rest }: KbdProps) {
  return <kbd className={cn(s.root, className)} {...rest} />
}
